import { useEffect, useState } from "react";

/**
 * Discreet back-to-top button.
 * Fades in after the user has scrolled past the hero (~600px).
 * Matches the Aoria palette and stays out of the way until needed.
 */
export default function BackToTop() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const onScroll = () => setVisible(window.scrollY > 600);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const handleClick = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    return (
        <button
            type="button"
            data-testid="back-to-top"
            aria-label="Retour en haut de la page"
            onClick={handleClick}
            className={`fixed bottom-6 right-6 md:bottom-8 md:right-8 z-40 inline-flex items-center justify-center w-11 h-11 md:w-12 md:h-12 bg-[#0D1B2A] text-[#FDFDFC] hover:bg-[#415A77] transition-all duration-500 shadow-[0_4px_14px_rgba(13,27,42,0.18)] ${
                visible
                    ? "opacity-100 translate-y-0 pointer-events-auto"
                    : "opacity-0 translate-y-3 pointer-events-none"
            }`}
        >
            <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeLinecap="square"
                aria-hidden="true"
            >
                <path d="M8 13 L8 3" />
                <path d="M3 8 L8 3 L13 8" />
            </svg>
        </button>
    );
}
